import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3250c184")

_pushScopeId("data-v-3250c184")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-md-center" }
const _hoisted_3 = { class: "col-lg-7 col-md-7 col-sm-12 register-form text-white" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col" }, [
    /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h5 mb-3 text-muted" }, " Corporate Account Application ")
  ])
], -1)
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "col" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h6 mb-3 text-muted" }, " This feature will be able soon. ")
], -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "form-group text-left" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "fullLegalName" }, "First Name*", -1)
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "form-group text-left" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "lastname" }, "Last Name*", -1)
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "form-group text-left" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { for: "email" }, "Email Address*", -1)
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = { class: "col-6" }
const _hoisted_23 = { class: "form-group text-left" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { for: "fullLegalName" }, "Password*", -1)
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = { class: "form-group text-left" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "fullLegalName" }, "Confirm Password*", -1)
const _hoisted_29 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = { class: "form-group text-left" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", { for: "entityName" }, "Entity Name*", -1)
const _hoisted_34 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_35 = { class: "col-12" }
const _hoisted_36 = { class: "form-group text-left" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", { for: "entityType" }, "Entity Type*", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("option", {
  value: undefined,
  selected: "",
  disabled: ""
}, " Select an Entity Type ", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("option", { value: "corporation" }, "Corporation", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("option", { value: "partnership" }, "Partnership", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("option", { value: "trust" }, "Trust", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("option", { value: "charity" }, "Charity", -1)
const _hoisted_43 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_44 = { class: "col-12" }
const _hoisted_45 = { class: "form-group text-left" }
const _hoisted_46 = /*#__PURE__*/_createVNode("label", { for: "corporateAdress" }, "Corporate Address*", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, [
  /*#__PURE__*/_createVNode("small", null, " Full Mailing Address (# Street, City, Province, Postal Code). ")
], -1)
const _hoisted_48 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_49 = { class: "col-12" }
const _hoisted_50 = { class: "form-group text-left" }
const _hoisted_51 = /*#__PURE__*/_createVNode("label", { for: "corporateAdress" }, "Company Website", -1)
const _hoisted_52 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_53 = { class: "col-12" }
const _hoisted_54 = { class: "form-group text-left" }
const _hoisted_55 = /*#__PURE__*/_createVNode("label", { for: "natureBusiness" }, "Nature of Business*", -1)
const _hoisted_56 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_57 = { class: "col-12" }
const _hoisted_58 = { class: "form-group text-left" }
const _hoisted_59 = /*#__PURE__*/_createVNode("label", { for: "natureBusiness" }, " Is your company required to register with FINTRAC as a MSB?* ", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = { class: "form-check form-check-inline" }
const _hoisted_62 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "hasFintracOrMsbYes"
}, " Yes ", -1)
const _hoisted_63 = { class: "form-check form-check-inline" }
const _hoisted_64 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "hasFintracOrMsbNo"
}, " No ", -1)
const _hoisted_65 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_66 = { class: "col-12" }
const _hoisted_67 = { class: "form-group text-left" }
const _hoisted_68 = /*#__PURE__*/_createVNode("label", { for: "articlesIncorporation" }, " Articles of Incorporation*: ", -1)
const _hoisted_69 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Current file ")
const _hoisted_71 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_72 = { class: "col-12" }
const _hoisted_73 = { class: "form-group text-left" }
const _hoisted_74 = /*#__PURE__*/_createVNode("label", { for: "addressProof" }, " Proof of Corporate Address*: ", -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, [
  /*#__PURE__*/_createVNode("small", null, " Full Mailing Address (# Street, City, Province, Postal Code). ")
], -1)
const _hoisted_76 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_77 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" Current file ")
const _hoisted_79 = { class: "col-12" }
const _hoisted_80 = { class: "form-group text-left" }
const _hoisted_81 = /*#__PURE__*/_createVNode("label", { for: "natureBusiness" }, " Is there an individual/entity that owns 25% or more of this company?* ", -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_83 = { class: "form-check form-check-inline" }
const _hoisted_84 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "hasIndividualEntityYes"
}, " Yes ", -1)
const _hoisted_85 = { class: "form-check form-check-inline" }
const _hoisted_86 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "hasIndividualEntityNo"
}, " No ", -1)
const _hoisted_87 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_88 = {
  key: 0,
  class: "row"
}
const _hoisted_89 = { class: "col" }
const _hoisted_90 = /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h5 mb-3 text-muted" }, " Beneficial Owners ", -1)
const _hoisted_91 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_92 = {
  key: 1,
  class: "row"
}
const _hoisted_93 = { class: "row" }
const _hoisted_94 = { class: "col-6" }
const _hoisted_95 = /*#__PURE__*/_createVNode("small", null, "Full Name", -1)
const _hoisted_96 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_97 = { class: "col-6" }
const _hoisted_98 = /*#__PURE__*/_createVNode("small", null, " Percentage Ownership: ", -1)
const _hoisted_99 = { class: "ml-2 text-muted" }
const _hoisted_100 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_101 = { class: "col-12" }
const _hoisted_102 = /*#__PURE__*/_createVNode("small", null, "Email", -1)
const _hoisted_103 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_104 = { class: "col-12" }
const _hoisted_105 = /*#__PURE__*/_createVNode("small", null, "Phone for Chat Group", -1)
const _hoisted_106 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_107 = { class: "col-12 mb-3" }
const _hoisted_108 = /*#__PURE__*/_createVNode("small", null, "ID*", -1)
const _hoisted_109 = /*#__PURE__*/_createVNode("small", { style: {"font-size":"10px"} }, " Please upload in colour, and the front and back if using license(s). ", -1)
const _hoisted_110 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_111 = { class: "col-12 mb-3" }
const _hoisted_112 = /*#__PURE__*/_createVNode("small", null, "ID (Back)", -1)
const _hoisted_113 = { class: "col-12" }
const _hoisted_114 = /*#__PURE__*/_createVNode("small", null, " The beneficial owner involved with, related, or closely associated with members of government?* ", -1)
const _hoisted_115 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_116 = { class: "form-check form-check-inline" }
const _hoisted_117 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "beneficialGovernmentYes"
}, " Yes ", -1)
const _hoisted_118 = { class: "form-check form-check-inline" }
const _hoisted_119 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "beneficialGovernmentNo"
}, " No ", -1)
const _hoisted_120 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_121 = { class: "col-12" }
const _hoisted_122 = /*#__PURE__*/_createVNode("small", null, " Beneficial owner(s) considered accredited investors?* ", -1)
const _hoisted_123 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_124 = { class: "form-check form-check-inline" }
const _hoisted_125 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "beneficialAccreditedYes"
}, " Yes ", -1)
const _hoisted_126 = { class: "form-check form-check-inline" }
const _hoisted_127 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "beneficialAccreditedNo"
}, " No ", -1)
const _hoisted_128 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_129 = /*#__PURE__*/_createVNode("small", { style: {"font-size":"10px"} }, [
  /*#__PURE__*/_createTextVNode(" Any one of the following: Income over $200k or Spousal income over $300k last 2 years, Combined spousal cash over $1m, Combined spousal net assets over $5m, "),
  /*#__PURE__*/_createVNode("b", null, "OR"),
  /*#__PURE__*/_createTextVNode(" registered investment advisor or dealer. ")
], -1)
const _hoisted_130 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_131 = { class: "col-12 text-right" }
const _hoisted_132 = { class: "col-12" }
const _hoisted_133 = /*#__PURE__*/_createVNode("h6", { class: "text-muted" }, "Beneficial Owner List", -1)
const _hoisted_134 = { class: "col-12" }
const _hoisted_135 = { class: "list-group" }
const _hoisted_136 = {
  key: 0,
  class: "list-group-item text-muted"
}
const _hoisted_137 = { class: "row" }
const _hoisted_138 = { class: "col-10" }
const _hoisted_139 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_140 = { class: "h5" }
const _hoisted_141 = { class: "col-2 text-right" }
const _hoisted_142 = {
  key: 2,
  class: "row mt-4"
}
const _hoisted_143 = { class: "col-12" }
const _hoisted_144 = { class: "form-group text-left" }
const _hoisted_145 = /*#__PURE__*/_createVNode("label", { for: "natureBusiness" }, " Beneficial owner(s) considered accredited investors?* ", -1)
const _hoisted_146 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_147 = { class: "form-check form-check-inline" }
const _hoisted_148 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "hasBeneficialOwnerYes"
}, " Yes ", -1)
const _hoisted_149 = { class: "form-check form-check-inline" }
const _hoisted_150 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "hasBeneficialOwnerNo"
}, " No ", -1)
const _hoisted_151 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, [
  /*#__PURE__*/_createVNode("small", null, " Any one of the following: Income over $200k or Spousal income over $300k last 2 years, Combined spousal cash over $1m, Combined spousal net assets over $5m, OR registered investment advisor or dealer. ")
], -1)
const _hoisted_152 = {
  key: 3,
  class: "row mt-4"
}
const _hoisted_153 = /*#__PURE__*/_createVNode("div", { class: "col" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h5 mb-3 text-muted" }, " Authorized Signers "),
  /*#__PURE__*/_createVNode("small", { class: "text-muted" }, " Please list any authorized signers not listed above. ")
], -1)
const _hoisted_154 = {
  key: 4,
  class: "row justify-content-left"
}
const _hoisted_155 = { class: "col-12" }
const _hoisted_156 = { class: "row" }
const _hoisted_157 = { class: "col-12" }
const _hoisted_158 = /*#__PURE__*/_createVNode("small", null, "Full Legal Name*", -1)
const _hoisted_159 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_160 = { class: "col-12" }
const _hoisted_161 = /*#__PURE__*/_createVNode("small", null, "Email*", -1)
const _hoisted_162 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_163 = { class: "col-12" }
const _hoisted_164 = /*#__PURE__*/_createVNode("small", null, " The beneficial owner involved with, related, or closely associated with members of government?* ", -1)
const _hoisted_165 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_166 = { class: "form-check form-check-inline" }
const _hoisted_167 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "signerGovernmentYes"
}, " Yes ", -1)
const _hoisted_168 = { class: "form-check form-check-inline" }
const _hoisted_169 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "signerGovernmentNo"
}, " No ", -1)
const _hoisted_170 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_171 = { class: "col-12 mb-3" }
const _hoisted_172 = /*#__PURE__*/_createVNode("small", null, "ID*", -1)
const _hoisted_173 = /*#__PURE__*/_createVNode("small", { style: {"font-size":"10px"} }, " Please upload in colour, and the front and back if using license(s). ", -1)
const _hoisted_174 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_175 = { class: "col-12 mb-3" }
const _hoisted_176 = /*#__PURE__*/_createVNode("small", null, "ID (Back)", -1)
const _hoisted_177 = { class: "col-12 text-right" }
const _hoisted_178 = /*#__PURE__*/_createVNode("h6", { class: "text-muted" }, "Authorized Signer List", -1)
const _hoisted_179 = { class: "col-12" }
const _hoisted_180 = { class: "list-group" }
const _hoisted_181 = {
  key: 0,
  class: "list-group-item text-muted"
}
const _hoisted_182 = { class: "row" }
const _hoisted_183 = { class: "col-10" }
const _hoisted_184 = { class: "col-2 text-right" }
const _hoisted_185 = { class: "row mt-4 justify-content-left" }
const _hoisted_186 = { class: "col-12" }
const _hoisted_187 = { class: "form-group text-left" }
const _hoisted_188 = /*#__PURE__*/_createVNode("label", null, " Is your company in the business of mining bitcoin?* ", -1)
const _hoisted_189 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_190 = { class: "form-check form-check-inline" }
const _hoisted_191 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "miningYes"
}, " Yes ", -1)
const _hoisted_192 = { class: "form-check form-check-inline" }
const _hoisted_193 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "miningNo"
}, " No ", -1)
const _hoisted_194 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_195 = {
  key: 0,
  class: "col-12"
}
const _hoisted_196 = { class: "form-group text-left" }
const _hoisted_197 = /*#__PURE__*/_createVNode("label", { for: "energyBill" }, " Please provide an Energy Bill dated within the past 3 months for each Mining Facility (If the Energy Bill for your Mining Facility is in the name of the property Lessor please also provide the lease agreement between your Company and the Lessor of each location).* ", -1)
const _hoisted_198 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_199 = /*#__PURE__*/_createTextVNode(" Current file ")
const _hoisted_200 = {
  key: 1,
  class: "col-12"
}
const _hoisted_201 = { class: "form-group text-left" }
const _hoisted_202 = /*#__PURE__*/_createVNode("label", { for: "walletAddress" }, " Please provide a wallet address where the bitcoin will be sent from* ", -1)
const _hoisted_203 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_204 = {
  key: 5,
  class: "row mt-4 justify-content-left"
}
const _hoisted_205 = { class: "col-12" }
const _hoisted_206 = { class: "form-group text-left" }
const _hoisted_207 = /*#__PURE__*/_createVNode("label", { for: "signerID" }, " How did you hear about us? ", -1)
const _hoisted_208 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, [
  /*#__PURE__*/_createVNode("small", null, " Let us know which partner or sales associate helped you find us! ")
], -1)
const _hoisted_209 = { class: "form-group" }
const _hoisted_210 = { class: "row justify-content-center" }
const _hoisted_211 = { class: "col-6" }
const _hoisted_212 = /*#__PURE__*/_createStaticVNode("<div class=\"row mt-3\" data-v-3250c184><div class=\"col\" data-v-3250c184><small class=\"text-muted\" data-v-3250c184> This site is protected by reCAPTCHA and the Google <a href=\"https://policies.google.com/privacy\" data-v-3250c184>Privacy Policy</a> and <a href=\"https://policies.google.com/terms\" data-v-3250c184>Terms of Service</a> apply. </small></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Password = _resolveComponent("Password")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_MultiSelect = _resolveComponent("MultiSelect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.disableForm)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("form", {
              id: "register",
              onSubmit: _cache[49] || (_cache[49] = _withModifiers(($event: any) => (_ctx.retryForm ? _ctx.updateForm() : _ctx.submit()), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _withDirectives(_createVNode("input", {
                      disabled: _ctx.retryForm,
                      type: "text",
                      class: "form-control",
                      id: "fullLegalName",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.registerBusinessForm.props.fullLegalName = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.registerBusinessForm.props.fullLegalName]
                    ]),
                    (_ctx.registerBusinessForm.controls.fullLegalName.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_13, _toDisplayString(_ctx.registerBusinessForm.controls.fullLegalName.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createVNode("input", {
                      disabled: _ctx.retryForm,
                      type: "text",
                      class: "form-control",
                      id: "lastname",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.registerBusinessForm.props.lastName = $event))
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.registerBusinessForm.props.lastName]
                    ]),
                    (_ctx.registerBusinessForm.controls.lastName.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_17, _toDisplayString(_ctx.registerBusinessForm.controls.lastName.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives(_createVNode("input", {
                      type: "email",
                      class: "form-control",
                      id: "email",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.registerBusinessForm.props.email = $event)),
                      disabled: _ctx.retryForm
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.registerBusinessForm.props.email]
                    ]),
                    (_ctx.registerBusinessForm.controls.email.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_21, _toDisplayString(_ctx.registerBusinessForm.controls.email.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_Password, {
                      style: {"width":"100%"},
                      inputStyle: "width:100%",
                      toggleMask: "",
                      feedback: false,
                      modelValue: _ctx.registerBusinessForm.props.password,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.registerBusinessForm.props.password = $event)),
                      disabled: _ctx.retryForm
                    }, null, 8, ["modelValue", "disabled"]),
                    (_ctx.registerBusinessForm.controls.password.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_25, _toDisplayString(_ctx.registerBusinessForm.controls.password.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_Password, {
                      style: {"width":"100%"},
                      inputStyle: "width:100%",
                      toggleMask: "",
                      feedback: false,
                      modelValue: _ctx.registerBusinessForm.props.confirmPassword,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.registerBusinessForm.props.confirmPassword = $event)),
                      disabled: _ctx.retryForm
                    }, null, 8, ["modelValue", "disabled"]),
                    (_ctx.registerBusinessForm.controls.confirmPassword.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_29, _toDisplayString(_ctx.registerBusinessForm.controls.confirmPassword
                          .errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "entityName",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.registerBusinessForm.props.entityName = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.registerBusinessForm.props.entityName]
                    ]),
                    (_ctx.registerBusinessForm.controls.entityName.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_34, _toDisplayString(_ctx.registerBusinessForm.controls.entityName.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _withDirectives(_createVNode("select", {
                      class: "form-control",
                      id: "entityType",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.registerBusinessForm.props.entityType = $event))
                    }, [
                      _hoisted_38,
                      _hoisted_39,
                      _hoisted_40,
                      _hoisted_41,
                      _hoisted_42
                    ], 512), [
                      [_vModelSelect, _ctx.registerBusinessForm.props.entityType]
                    ]),
                    (_ctx.registerBusinessForm.controls.entityType.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_43, _toDisplayString(_ctx.registerBusinessForm.controls.entityType.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_44, [
                  _createVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "corporateAdress",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.registerBusinessForm.props.corporateAdress = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.registerBusinessForm.props.corporateAdress]
                    ]),
                    _hoisted_47,
                    (_ctx.registerBusinessForm.controls.corporateAdress.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_48, _toDisplayString(_ctx.registerBusinessForm.controls.corporateAdress
                          .errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _withDirectives(_createVNode("input", {
                      type: "url",
                      class: "form-control",
                      id: "companyWebsite",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.registerBusinessForm.props.companyWebsite = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.registerBusinessForm.props.companyWebsite]
                    ]),
                    (_ctx.registerBusinessForm.controls.companyWebsite.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_52, _toDisplayString(_ctx.registerBusinessForm.controls.companyWebsite
                          .errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "natureBusiness",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.registerBusinessForm.props.natureBusiness = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.registerBusinessForm.props.natureBusiness]
                    ]),
                    (_ctx.registerBusinessForm.controls.natureBusiness.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_56, _toDisplayString(_ctx.registerBusinessForm.controls.natureBusiness
                          .errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_57, [
                  _createVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _hoisted_60,
                    _createVNode("div", _hoisted_61, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        id: "hasFintracOrMsbYes",
                        value: true,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.registerBusinessForm.props.hasFintracOrMsb = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.registerBusinessForm.props.hasFintracOrMsb]
                      ]),
                      _hoisted_62
                    ]),
                    _createVNode("div", _hoisted_63, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        id: "hasFintracOrMsbNo",
                        value: false,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.registerBusinessForm.props.hasFintracOrMsb = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.registerBusinessForm.props.hasFintracOrMsb]
                      ]),
                      _hoisted_64
                    ]),
                    (_ctx.registerBusinessForm.controls.hasFintracOrMsb.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_65, _toDisplayString(_ctx.registerBusinessForm.controls.hasFintracOrMsb
                          .errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_66, [
                  _createVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode("input", {
                      onInput: _cache[13] || (_cache[13] = e => _ctx.onEntryFile(e, 'articlesIncorporation')),
                      id: "articlesIncorporation",
                      type: "file",
                      class: "form-control",
                      accept: "application/pdf,image/png,image/jpeg,image/jpg,.doc,.docx,"
                    }, null, 32),
                    (
                        _ctx.retryForm &&
                          _ctx.registerBusinessForm.props.articlesIncorporation
                      )
                      ? (_openBlock(), _createBlock("small", _hoisted_69, [
                          _hoisted_70,
                          _createVNode("a", {
                            class: "link pointer",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (
                          _ctx.downloadDocument(
                            _ctx.registerBusinessForm.props.articlesIncorporation
                          )
                        ))
                          }, _toDisplayString(_ctx.registerBusinessForm.props.articlesIncorporation.key), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (
                        _ctx.registerBusinessForm.controls.articlesIncorporation
                          .dirty
                      )
                      ? (_openBlock(), _createBlock("small", _hoisted_71, _toDisplayString(_ctx.registerBusinessForm.controls.articlesIncorporation
                          .errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_72, [
                  _createVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createVNode("input", {
                      onInput: _cache[15] || (_cache[15] = e => _ctx.onEntryFile(e, 'addressProof')),
                      id: "addressProof",
                      type: "file",
                      class: "form-control",
                      accept: "application/pdf,image/png,image/jpeg,image/jpg,.doc,.docx,"
                    }, null, 32),
                    _hoisted_75,
                    (_ctx.registerBusinessForm.controls.addressProof.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_76, _toDisplayString(_ctx.registerBusinessForm.controls.addressProof.errorMessage), 1))
                      : _createCommentVNode("", true),
                    (
                        _ctx.retryForm && _ctx.registerBusinessForm.props.addressProof
                      )
                      ? (_openBlock(), _createBlock("small", _hoisted_77, [
                          _hoisted_78,
                          _createVNode("a", {
                            class: "link pointer",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (
                          _ctx.downloadDocument(
                            _ctx.registerBusinessForm.props.addressProof
                          )
                        ))
                          }, _toDisplayString(_ctx.registerBusinessForm.props.addressProof.key), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_79, [
                  _createVNode("div", _hoisted_80, [
                    _hoisted_81,
                    _hoisted_82,
                    _createVNode("div", _hoisted_83, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        id: "hasIndividualEntityYes",
                        value: true,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.registerBusinessForm.props.hasIndividualEntity = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.registerBusinessForm.props.hasIndividualEntity]
                      ]),
                      _hoisted_84
                    ]),
                    _createVNode("div", _hoisted_85, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        id: "hasIndividualEntityNo",
                        value: false,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.registerBusinessForm.props.hasIndividualEntity = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.registerBusinessForm.props.hasIndividualEntity]
                      ]),
                      _hoisted_86
                    ]),
                    (
                        _ctx.registerBusinessForm.controls.hasIndividualEntity.dirty
                      )
                      ? (_openBlock(), _createBlock("small", _hoisted_87, _toDisplayString(_ctx.registerBusinessForm.controls.hasIndividualEntity
                          .errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (!_ctx.retryForm)
                ? (_openBlock(), _createBlock("div", _hoisted_88, [
                    _createVNode("div", _hoisted_89, [
                      _hoisted_90,
                      (_ctx.registerBusinessForm.props.hasIndividualEntity)
                        ? (_openBlock(), _createBlock("small", _hoisted_91, " Please list any individuals or entities with 25% or more ownership "))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.registerBusinessForm.props.hasIndividualEntity && !_ctx.retryForm
                )
                ? (_openBlock(), _createBlock("div", _hoisted_92, [
                    _createVNode(_component_Dialog, {
                      style: {"min-width":"400px","max-width":"600px"},
                      header: "Add Beneficial Owner",
                      visible: _ctx.showBeneficialModal,
                      "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => (_ctx.showBeneficialModal = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_93, [
                          _createVNode("div", _hoisted_94, [
                            _hoisted_95,
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.beneficialForm.props.name = $event)),
                              class: "form-control form-control-sm",
                              type: "text"
                            }, null, 512), [
                              [_vModelText, _ctx.beneficialForm.props.name]
                            ]),
                            (_ctx.beneficialForm.controls.name.dirty)
                              ? (_openBlock(), _createBlock("small", _hoisted_96, _toDisplayString(_ctx.beneficialForm.controls.name.errorMessage), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_97, [
                            _hoisted_98,
                            _createVNode(_component_InputNumber, {
                              id: "minmax",
                              modelValue: _ctx.beneficialForm.props.percentage,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.beneficialForm.props.percentage = $event)),
                              mode: "decimal",
                              min: 1,
                              max: _ctx.aviablePercentage,
                              onInput: _ctx.checkRange,
                              showButtons: "",
                              style: {"max-height":"33px"},
                              suffix: "%"
                            }, null, 8, ["modelValue", "max", "onInput"]),
                            _createVNode("small", _hoisted_99, " Available: " + _toDisplayString(_ctx.percentageShow || 0) + "% ", 1),
                            (_ctx.beneficialForm.controls.percentage.dirty)
                              ? (_openBlock(), _createBlock("small", _hoisted_100, _toDisplayString(_ctx.beneficialForm.controls.percentage.errorMessage), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_101, [
                            _hoisted_102,
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.beneficialForm.props.email = $event)),
                              class: "form-control form-control-sm",
                              type: "email"
                            }, null, 512), [
                              [_vModelText, _ctx.beneficialForm.props.email]
                            ]),
                            (_ctx.beneficialForm.controls.email.dirty)
                              ? (_openBlock(), _createBlock("small", _hoisted_103, _toDisplayString(_ctx.beneficialForm.controls.email.errorMessage), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_104, [
                            _hoisted_105,
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.beneficialForm.props.phoneNumber = $event)),
                              class: "form-control form-control-sm",
                              type: "text"
                            }, null, 512), [
                              [_vModelText, _ctx.beneficialForm.props.phoneNumber]
                            ]),
                            (_ctx.beneficialForm.controls.phoneNumber.dirty)
                              ? (_openBlock(), _createBlock("small", _hoisted_106, _toDisplayString(_ctx.beneficialForm.controls.phoneNumber.errorMessage), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_107, [
                            _hoisted_108,
                            _createVNode("input", {
                              onInput: _cache[23] || (_cache[23] = e => _ctx.onEntryFile(e, 'idBeneficial')),
                              id: "idBeneficial",
                              type: "file",
                              class: "form-control form-control-sm",
                              accept: "application/pdf,image/png,image/jpeg,image/jpg,.doc,.docx,"
                            }, null, 32),
                            _hoisted_109,
                            (_ctx.beneficialForm.controls.identification.dirty)
                              ? (_openBlock(), _createBlock("small", _hoisted_110, _toDisplayString(_ctx.beneficialForm.controls.identification.errorMessage), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_111, [
                            _hoisted_112,
                            _createVNode("input", {
                              onInput: _cache[24] || (_cache[24] = e => _ctx.onEntryFile(e, 'idBeneficialBack')),
                              id: "idBeneficial",
                              type: "file",
                              class: "form-control form-control-sm",
                              accept: "application/pdf,image/png,image/jpeg,image/jpg,.doc,.docx,"
                            }, null, 32)
                          ]),
                          _createVNode("div", _hoisted_113, [
                            _hoisted_114,
                            _hoisted_115,
                            _createVNode("div", _hoisted_116, [
                              _withDirectives(_createVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                id: "beneficialGovernmentYes",
                                value: true,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.beneficialForm.props.withGovernment = $event))
                              }, null, 512), [
                                [_vModelRadio, _ctx.beneficialForm.props.withGovernment]
                              ]),
                              _hoisted_117
                            ]),
                            _createVNode("div", _hoisted_118, [
                              _withDirectives(_createVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                id: "beneficialGovernmentNo",
                                value: false,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.beneficialForm.props.withGovernment = $event))
                              }, null, 512), [
                                [_vModelRadio, _ctx.beneficialForm.props.withGovernment]
                              ]),
                              _hoisted_119
                            ]),
                            (_ctx.beneficialForm.controls.withGovernment.dirty)
                              ? (_openBlock(), _createBlock("small", _hoisted_120, _toDisplayString(_ctx.beneficialForm.controls.withGovernment.errorMessage), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_121, [
                            _hoisted_122,
                            _hoisted_123,
                            _createVNode("div", _hoisted_124, [
                              _withDirectives(_createVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                id: "beneficialAccreditedYes",
                                value: true,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.beneficialForm.props.accredited = $event))
                              }, null, 512), [
                                [_vModelRadio, _ctx.beneficialForm.props.accredited]
                              ]),
                              _hoisted_125
                            ]),
                            _createVNode("div", _hoisted_126, [
                              _withDirectives(_createVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                id: "beneficialAccreditedNo",
                                value: false,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.beneficialForm.props.accredited = $event))
                              }, null, 512), [
                                [_vModelRadio, _ctx.beneficialForm.props.accredited]
                              ]),
                              _hoisted_127
                            ]),
                            _hoisted_128,
                            _hoisted_129,
                            (_ctx.beneficialForm.controls.accredited.dirty)
                              ? (_openBlock(), _createBlock("small", _hoisted_130, _toDisplayString(_ctx.beneficialForm.controls.accredited.errorMessage), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_131, [
                            _createVNode("button", {
                              type: "button",
                              onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.addBeneficialOwner && _ctx.addBeneficialOwner(...args))),
                              class: "btn btn-sm btn-primary"
                            }, " Save ")
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["visible"]),
                    _createVNode("div", _hoisted_132, [
                      _createVNode(_component_Toolbar, null, {
                        left: _withId(() => [
                          _hoisted_133
                        ]),
                        right: _withId(() => [
                          _createVNode("button", {
                            disabled: _ctx.disableForm || _ctx.getPercentage === 0,
                            onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.openBeneficialModal && _ctx.openBeneficialModal(...args))),
                            type: "button",
                            class: "btn btn-sm btn-success"
                          }, " Add + ", 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_134, [
                      _createVNode("ul", _hoisted_135, [
                        (_ctx.beneficialList.length === 0)
                          ? (_openBlock(), _createBlock("li", _hoisted_136, " It seems you don't have registered Beneficial Owners yet. "))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.beneficialList, (beneficial) => {
                          return (_openBlock(), _createBlock("li", {
                            key: beneficial.email,
                            class: "list-group-item text-muted text-left"
                          }, [
                            _createVNode("div", _hoisted_137, [
                              _createVNode("div", _hoisted_138, [
                                _createTextVNode(_toDisplayString(beneficial.name) + " ", 1),
                                _createVNode("b", null, _toDisplayString(beneficial.email), 1),
                                _hoisted_139,
                                _createVNode("span", _hoisted_140, _toDisplayString(beneficial.percentage || beneficial.equity) + " %", 1)
                              ]),
                              _createVNode("div", _hoisted_141, [
                                _createVNode("button", {
                                  onClick: ($event: any) => (_ctx.removeBeneficial(beneficial.email)),
                                  type: "button",
                                  class: "btn btn-sm btn-light"
                                }, " X ", 8, ["onClick"])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.registerBusinessForm.props.hasIndividualEntity)
                ? (_openBlock(), _createBlock("div", _hoisted_142, [
                    _createVNode("div", _hoisted_143, [
                      _createVNode("div", _hoisted_144, [
                        _hoisted_145,
                        _hoisted_146,
                        _createVNode("div", _hoisted_147, [
                          _withDirectives(_createVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            id: "hasBeneficialOwnerYes",
                            value: true,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.registerBusinessForm.props.hasBeneficialOwner = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.registerBusinessForm.props.hasBeneficialOwner]
                          ]),
                          _hoisted_148
                        ]),
                        _createVNode("div", _hoisted_149, [
                          _withDirectives(_createVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            id: "hasBeneficialOwnerNo",
                            value: false,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.registerBusinessForm.props.hasBeneficialOwner = $event))
                          }, null, 512), [
                            [_vModelRadio, _ctx.registerBusinessForm.props.hasBeneficialOwner]
                          ]),
                          _hoisted_150
                        ]),
                        _hoisted_151
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.retryForm)
                ? (_openBlock(), _createBlock("div", _hoisted_152, [
                    _hoisted_153
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.retryForm)
                ? (_openBlock(), _createBlock("div", _hoisted_154, [
                    _createVNode("div", _hoisted_155, [
                      _createVNode(_component_Dialog, {
                        style: {"min-width":"400px","max-width":"600px"},
                        header: "Add Authorized Signer",
                        visible: _ctx.showSignerModal,
                        "onUpdate:visible": _cache[41] || (_cache[41] = ($event: any) => (_ctx.showSignerModal = $event))
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_156, [
                            _createVNode("div", _hoisted_157, [
                              _hoisted_158,
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.signerForm.props.name = $event)),
                                class: "form-control form-control-sm",
                                type: "text"
                              }, null, 512), [
                                [_vModelText, _ctx.signerForm.props.name]
                              ]),
                              (_ctx.signerForm.controls.name.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_159, _toDisplayString(_ctx.signerForm.controls.name.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_160, [
                              _hoisted_161,
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.signerForm.props.email = $event)),
                                class: "form-control form-control-sm",
                                type: "email"
                              }, null, 512), [
                                [_vModelText, _ctx.signerForm.props.email]
                              ]),
                              (_ctx.signerForm.controls.email.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_162, _toDisplayString(_ctx.signerForm.controls.email.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_163, [
                              _hoisted_164,
                              _hoisted_165,
                              _createVNode("div", _hoisted_166, [
                                _withDirectives(_createVNode("input", {
                                  class: "form-check-input",
                                  type: "radio",
                                  id: "signerGovernmentYes",
                                  value: true,
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.signerForm.props.withGovernment = $event))
                                }, null, 512), [
                                  [_vModelRadio, _ctx.signerForm.props.withGovernment]
                                ]),
                                _hoisted_167
                              ]),
                              _createVNode("div", _hoisted_168, [
                                _withDirectives(_createVNode("input", {
                                  class: "form-check-input",
                                  type: "radio",
                                  id: "signerGovernmentNo",
                                  value: false,
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.signerForm.props.withGovernment = $event))
                                }, null, 512), [
                                  [_vModelRadio, _ctx.signerForm.props.withGovernment]
                                ]),
                                _hoisted_169
                              ]),
                              (_ctx.signerForm.controls.withGovernment.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_170, _toDisplayString(_ctx.signerForm.controls.withGovernment.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_171, [
                              _hoisted_172,
                              _createVNode("input", {
                                onInput: _cache[38] || (_cache[38] = e => _ctx.onEntryFile(e, 'idSigner')),
                                id: "idSigner",
                                type: "file",
                                class: "form-control form-control-sm",
                                accept: "application/pdf,image/png,image/jpeg,image/jpg,.doc,.docx,"
                              }, null, 32),
                              _hoisted_173,
                              (_ctx.signerForm.controls.identification.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_174, _toDisplayString(_ctx.signerForm.controls.identification.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_175, [
                              _hoisted_176,
                              _createVNode("input", {
                                onInput: _cache[39] || (_cache[39] = e => _ctx.onEntryFile(e, 'idSignerBack')),
                                id: "idSigner",
                                type: "file",
                                class: "form-control form-control-sm",
                                accept: "application/pdf,image/png,image/jpeg,image/jpg,.doc,.docx,"
                              }, null, 32)
                            ]),
                            _createVNode("div", _hoisted_177, [
                              _createVNode("button", {
                                type: "button",
                                onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.addAuthorizedSigner && _ctx.addAuthorizedSigner(...args))),
                                class: "btn btn-sm btn-primary"
                              }, " Save ")
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["visible"]),
                      _createVNode(_component_Toolbar, null, {
                        left: _withId(() => [
                          _hoisted_178
                        ]),
                        right: _withId(() => [
                          _createVNode("button", {
                            disabled: _ctx.disableForm,
                            onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.openSignerModal && _ctx.openSignerModal(...args))),
                            type: "button",
                            class: "btn btn-sm btn-success"
                          }, " Add + ", 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_179, [
                      _createVNode("ul", _hoisted_180, [
                        (_ctx.signerList.length === 0)
                          ? (_openBlock(), _createBlock("li", _hoisted_181, " It seems you don't have registered Authorized Signer yet. "))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.signerList, (signer) => {
                          return (_openBlock(), _createBlock("li", {
                            key: signer.email,
                            class: "list-group-item text-muted text-left"
                          }, [
                            _createVNode("div", _hoisted_182, [
                              _createVNode("div", _hoisted_183, [
                                _createTextVNode(_toDisplayString(signer.name) + " ", 1),
                                _createVNode("b", null, _toDisplayString(signer.email), 1)
                              ]),
                              _createVNode("div", _hoisted_184, [
                                _createVNode("button", {
                                  onClick: ($event: any) => (_ctx.removeSigner(signer.email)),
                                  type: "button",
                                  class: "btn btn-sm btn-light"
                                }, " X ", 8, ["onClick"])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_185, [
                _createVNode("div", _hoisted_186, [
                  _createVNode("div", _hoisted_187, [
                    _hoisted_188,
                    _hoisted_189,
                    _createVNode("div", _hoisted_190, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        id: "miningYes",
                        value: true,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.registerBusinessForm.props.miningBitcoin = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.registerBusinessForm.props.miningBitcoin]
                      ]),
                      _hoisted_191
                    ]),
                    _createVNode("div", _hoisted_192, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        id: "miningNo",
                        value: false,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.registerBusinessForm.props.miningBitcoin = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.registerBusinessForm.props.miningBitcoin]
                      ]),
                      _hoisted_193
                    ]),
                    (_ctx.registerBusinessForm.controls.miningBitcoin.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_194, _toDisplayString(_ctx.registerBusinessForm.controls.miningBitcoin.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.registerBusinessForm.props.miningBitcoin)
                  ? (_openBlock(), _createBlock("div", _hoisted_195, [
                      _createVNode("div", _hoisted_196, [
                        _hoisted_197,
                        _createVNode("input", {
                          onInput: _cache[45] || (_cache[45] = e => _ctx.onEntryFile(e, 'energyBill')),
                          id: "energyBill",
                          type: "file",
                          class: "form-control",
                          accept: "application/pdf,image/png,image/jpeg,image/jpg,.doc,.docx,"
                        }, null, 32),
                        (_ctx.retryForm && _ctx.registerBusinessForm.props.energyBill)
                          ? (_openBlock(), _createBlock("small", _hoisted_198, [
                              _hoisted_199,
                              _createVNode("a", {
                                class: "link pointer",
                                onClick: _cache[46] || (_cache[46] = ($event: any) => (
                          _ctx.downloadDocument(
                            _ctx.registerBusinessForm.props.energyBill
                          )
                        ))
                              }, _toDisplayString(_ctx.registerBusinessForm.props.energyBill.key), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.registerBusinessForm.props.miningBitcoin)
                  ? (_openBlock(), _createBlock("div", _hoisted_200, [
                      _createVNode("div", _hoisted_201, [
                        _hoisted_202,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "walletAddress",
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.registerBusinessForm.props.walletAddress = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.registerBusinessForm.props.walletAddress]
                        ]),
                        (_ctx.registerBusinessForm.controls.walletAddress.dirty)
                          ? (_openBlock(), _createBlock("small", _hoisted_203, _toDisplayString(_ctx.registerBusinessForm.controls.walletAddress.errorMessage), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.retryForm)
                ? (_openBlock(), _createBlock("div", _hoisted_204, [
                    _createVNode("div", _hoisted_205, [
                      _createVNode("div", _hoisted_206, [
                        _hoisted_207,
                        _hoisted_208,
                        _createVNode(_component_MultiSelect, {
                          style: {"width":"100%","color":"gray"},
                          inputStyle: "width:100%",
                          modelValue: _ctx.registerBusinessForm.props.partnerAssociate,
                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.registerBusinessForm.props.partnerAssociate = $event)),
                          options: _ctx.partners,
                          optionLabel: "name",
                          placeholder: "Select Partners"
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_209, [
                _createVNode("div", _hoisted_210, [
                  _createVNode("div", _hoisted_211, [
                    _createVNode("button", {
                      disabled: _ctx.disableForm,
                      type: "submit",
                      class: "btn btn-register text-white"
                    }, " Register ", 8, ["disabled"])
                  ])
                ])
              ]),
              _hoisted_212
            ], 32)
          ])
        ])
      ])
    ])
  ]))
})